import { transparentize } from 'polished'
import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	$isDisabled: boolean
	$isSelected: boolean
}

export const Container = styled.div<Props>`
	--application-detail-background: ${({ $isSelected }) => ($isSelected ? '#eaefcb' : '#dde0d7')};
	background-color: ${({ theme, $isSelected }) =>
		$isSelected ? transparentize(0.86, theme.color.primary) : 'rgba(241, 241, 237, 0.88)'};
	border-radius: 16px;
	border: 2px solid ${({ theme, $isSelected }) => ($isSelected ? theme.color.pageHeader : 'transparent')};
	color: ${helpers.color.pageHeader};
	height: 221px;
	max-width: 100%;
	opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
	padding: 16px;
	text-align: left;
	transition:
		background-color 150ms ease-in-out,
		border-color 150ms ease-in-out;
	width: 377px;

	input[type='radio'] {
		height: 1px;
		opacity: 0;
		position: absolute;
		width: 1px;
	}

	&:has(input[type='radio']:focus-visible) {
		outline: 2px solid ${helpers.color.link};
		outline-offset: 2px;
	}

	&:has(input[type='radio']:not(:disabled)):hover {
		border-color: ${helpers.color.pageHeader};
	}

`
